console.log('ANVIL  | 01 |  src/ui-menu.js')








/* ************************ */
// ui-menu.js
const section_btn = [
  document.getElementById('btnSection-one'),    // Logo Upload Placement
  document.getElementById('btnSection-two'),    // Metal
  document.getElementById('btnSection-three'),  // Pattern & Colors
  document.getElementById('btnSection-four'),   // Accessories
  document.getElementById('btnSection-five'),   // Cart
  document.getElementById('btnSection-six'),    // Settings
]
const sections = [
  document.getElementById('section-one'),
  document.getElementById('section-two'),
  document.getElementById('section-three'),
  document.getElementById('section-four'),
  document.getElementById('section-five'),
  document.getElementById('section-six')
]
// () to Hide All
const hideUI = (()=> {
  sections.forEach((s)=>{s.style.display="none";})
  section_btn.forEach((b)=>{b.classList.remove('bf-menu-selected')})
});
hideUI();
// Show first on load
sections[0].style.display = "block";
section_btn[0].classList.add('bf-menu-selected');
// Event Listeners for Each Section
section_btn.forEach((b,i)=>{
  b.addEventListener('click',()=>{
    hideUI();
    sections[i].style.display="block";
    b.classList.add('bf-menu-selected')
  })
})


// ====== TOGGLE + TAB SWITCHING ======
 // Settings toggle
      const fxToggle = document.getElementById('fxSettingsToggle');
      const fxBar = document.getElementById('fxSettingsBar');
      if (fxToggle && fxBar) {
        fxToggle.addEventListener('click', () => {
          const open = fxBar.classList.toggle('open');
          fxToggle.setAttribute('aria-expanded', String(open));
          fxBar.setAttribute('aria-hidden', String(!open));
        });
      }

      // Tabs share the same show/hide logic and just toggle your #section-* blocks
      const sections2 = ['#section-one','#section-two','#section-three','#section-four','#section-five','#section-six']
        .map(sel => document.querySelector(sel))
        .filter(Boolean);

      function showSection(targetSel) {
        sections2.forEach(sec => { sec.style.display = (('#'+sec.id) === targetSel) ? '' : 'none'; });
        // desktop active
        document.querySelectorAll('#fxTabsDesktop .fx-tab').forEach(b=>{
          b.classList.toggle('active', b.dataset.target === targetSel);
          b.setAttribute('aria-selected', String(b.dataset.target === targetSel));
        });
        // mobile active
        document.querySelectorAll('#fxTabsMobile button').forEach(b=>{
          b.classList.toggle('active', b.dataset.target === targetSel);
        });
      }

      document.querySelectorAll('#fxTabsDesktop .fx-tab').forEach(b=>{
        b.addEventListener('click', ()=> showSection(b.dataset.target));
      });
      document.querySelectorAll('#fxTabsMobile button').forEach(b=>{
        b.addEventListener('click', ()=> showSection(b.dataset.target));
      });

      // Default visible (matches your current default)
      showSection('#section-one');

      // Keep blurb text in sync
      const d = document.getElementById('fxBlurbDesktop');
      const m = document.getElementById('fxBlurbMobile');
      if (d && m) {
        const obs = new MutationObserver(()=> m.textContent = d.textContent);
        obs.observe(d, {subtree:true, characterData:true, childList:true});
      }

// ====== MUSIC & SETTINGS GRID ===========
(function settingsGrid(){
  const getAmb = () => document.getElementById('bf-ambience');
  const getSfx = () => document.getElementById('coinFlipSound');

  // Delegated clicks inside Section 6
  document.querySelector('#section-six .settings-grid')?.addEventListener('click', async (e) => {
    const el = e.target.closest('span');
    if (!el) return;

    // Map to existing radios
    const forId = el.getAttribute('data-for');
    if (forId){
      const input = document.getElementById(forId);
      if (input){
        input.checked = true;
        input.dispatchEvent(new Event('input', {bubbles:true}));
        input.dispatchEvent(new Event('change', {bubbles:true}));
        syncSelected();
      }
      return;
    }

    // Music On/Off
    if (el.hasAttribute('data-music')){
      const amb = getAmb();
      const on = el.getAttribute('data-music') === 'on';
      if (amb){
        amb.muted = !on;
        try {
          if (on && amb.paused) {
            // iOS requires inline + user gesture; this click counts.
            await amb.play();
          }
        } catch(_) { /* ignore block */ }
      }
      syncSelected();
    }
     // SFX On/Off
    if (el.hasAttribute('data-sfx')){
      // to do fix this
      const amb = getSfx()
      const on = el.getAttribute('data-sfx') === 'on';
      if (amb){
        amb.muted = !on;
        try {
          if (on && amb.paused) {
            // iOS requires inline + user gesture; this click counts.
            await amb.play();
          }
        } catch(_) { /* ignore block */ }
      }
      syncSelected();
    }
  });

  // Volume sliders (resolve elements at use-time)
  const musicVol = document.getElementById('musicVol');
  const sfxVol   = document.getElementById('sfxVol');

// new 11-17

document.addEventListener('click', (e) => {
  const t = e.target;

  if (!(t instanceof HTMLElement)) return;

  if (t.id === 'music-on') {
    musicVol.disabled = false;
  } else if (t.id === 'music-off') {
    musicVol.disabled = true;
  } else if (t.id === 'sfx-on') {
    sfxVol.disabled = false;
  } else if (t.id === 'sfx-off') {
    sfxVol.disabled = true;
  }
});
// end new

  const clamp = v => Math.max(0, Math.min(1, (Number(v)||0)/100));

  musicVol?.addEventListener('input', () => {
    const amb = getAmb();
    if (amb) amb.volume = clamp(musicVol.value);
    
  });
  sfxVol?.addEventListener('input',   () => {
    const sfx = getSfx();
    if (sfx) sfx.volume = clamp(sfxVol.value);
    // Play coin flip on change
    const flipSound = document.getElementById('coinFlipSound');
    if (flipSound) {
      flipSound.playing = true;
      flipSound.currentTime = 0;
      flipSound.loop = false;
      flipSound.volume = 0.7;
      flipSound.play().catch(()=>{});
      flipSound.onended = () => (flipSound.playing = false);
    }
  });

  function mark(groupSel, ids){
    const spans = document.querySelectorAll(groupSel + ' span');
    spans.forEach(s => s.classList.remove('selected'));
    ids.forEach(id => {
      const match = [...spans].find(s => s.getAttribute('data-for') === id);
      if (match) match.classList.add('selected');
    });
  }

  function syncSelected(){
    // Render Edge
    const rq = document.querySelector('input[name="rim-quality"]:checked');
    const rqId = rq?.id || '';
    const edgeOn = rqId && rqId !== 'rim-off';
    const edgeGroup = document.querySelector('#section-six .button.two [data-for="rim-low"]')?.parentElement;
    if (edgeGroup){
      edgeGroup.querySelectorAll('span').forEach(s => s.classList.remove('selected'));
      (edgeOn
        ? edgeGroup.querySelector('[data-for="rim-low"]')
        : edgeGroup.querySelector('[data-for="rim-off"]')
      )?.classList.add('selected');
    }

    // 3D Quality
    mark('#section-six .button.three[aria-label="3D Render Quality"]', [rqId]);

    // Rim Thickness
    const rd = document.querySelector('input[name="rim-diameter"]:checked');
    mark('#section-six .button.three[aria-label="Rim Thickness"]', [rd?.id || '']);

    // Music On/Off
    const amb = getAmb();
    const musicOn = amb ? !amb.muted : false;
    document.querySelectorAll('#section-six [data-music]').forEach(s=> s.classList.remove('selected'));
    document
      .querySelector(`#section-six [data-music="${musicOn?'on':'off'}"]`)
      ?.classList.add('selected');

    // Init slider values once elements exist
    if (amb && musicVol && musicVol.dataset.init !== '1'){
      musicVol.value = Math.round((amb.volume ?? 0.6)*100);
      musicVol.dataset.init = '1';
    }
    // const sfx = getSfx();
    // if (sfx && sfxVol && sfxVol.dataset.init !== '1'){
    //   sfxVol.value = Math.round((sfx.volume ?? 0.8)*100);
    //   sfxVol.dataset.init = '1';
    // }
     // SFX On/Off
    // const anySfx = document.querySelector('audio[data-sfx]');
    // const sfxOn = anySfx ? !anySfx.muted : false;

    // document.querySelectorAll('#section-six [data-sfx]').forEach(s =>
    //   s.classList.remove('selected')
    // );

    // document
    //   .querySelector(`#section-six [data-sfx="${sfxOn ? 'on' : 'off'}"]`)
    //   ?.classList.add('selected');
     // SFX On/Off
    const anySfx = document.querySelector('audio[data-sfx]');
    const sfxOn = anySfx ? !anySfx.muted : false;
    document.querySelectorAll('#section-six [data-sfx]').forEach(s =>
      s.classList.remove('selected')
    );
    document
      .querySelector(`#section-six [data-sfx="${sfxOn ? 'on' : 'off'}"]`)
      ?.classList.add('selected');

    // Init slider values once elements exist
    if (amb && musicVol && musicVol.dataset.init !== '1'){
      musicVol.value = Math.round((amb.volume ?? 0.6)*100);
      musicVol.dataset.init = '1';
    }
    const sfx = getSfx();
    if (sfx && sfxVol && sfxVol.dataset.init !== '1'){
      sfxVol.value = Math.round((sfx.volume ?? 0.8)*100);
      sfxVol.dataset.init = '1';
    }
  }

  // Sync when radios change elsewhere
  document.querySelectorAll('input[name="rim-quality"], input[name="rim-diameter"]').forEach(r=>{
    r.addEventListener('change', syncSelected);
    r.addEventListener('input',  syncSelected);
  });

  // Run once now; run again after window load in case audio tags come later
  syncSelected();
  window.addEventListener('load', syncSelected);
})();

// NEW
// helpers
const clamp = v => Math.max(0, Math.min(1, (Number(v)||0)/100));
const sfxSlider = document.getElementById('sfxVol');

function setAllSfxVolume(vol){
  document.querySelectorAll('audio[data-sfx]').forEach(a => { a.volume = vol; });
  // remember current for late-created sounds
  window.__SFX_VOL__ = vol;
}

// init slider from any existing audio (or default)
(function initSfxVol(){
  const first = document.querySelector('audio[data-sfx]');
  const vol = (typeof window.__SFX_VOL__ === 'number') ? window.__SFX_VOL__ : (first ? first.volume : 0.8);
  if (sfxSlider) sfxSlider.value = Math.round(vol*100);
  setAllSfxVolume(vol);
})();

// live update when slider moves
sfxSlider?.addEventListener('input', () => {
  setAllSfxVolume(clamp(sfxSlider.value));
});

// whenever ANY audio with data-sfx starts playing (including clones/new Audio()), force volume
document.addEventListener('play', (e) => {
  const a = e.target;
  if (a && a.tagName === 'AUDIO' && a.dataset && 'sfx' in a.dataset){
    a.volume = (typeof window.__SFX_VOL__ === 'number') ? window.__SFX_VOL__ : a.volume;
  }
}, true);




   // Open/close dropdowns
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.fx-setting-btn');
    const outside = !e.target.closest('.fx-setting');
    if (btn) {
      document.querySelectorAll('.fx-dd.open').forEach(dd => dd.classList.remove('open'));
      const dd = btn.parentElement.querySelector('.fx-dd');
      if (dd) dd.classList.add('open');
      return;
    }
    if (outside) document.querySelectorAll('.fx-dd.open').forEach(dd => dd.classList.remove('open'));
  });

  // Critical: on touch devices, clicking a <label for="..."> can be lost if the menu closes first.
  // Use pointerdown to trigger the radio, then close after the click registers.
  document.addEventListener('pointerdown', (e) => {
    const lab = e.target.closest('.fx-dd-item[for]');
    if (!lab) return;
    e.preventDefault(); // stop text selection / duplicate clicks
    const id = lab.getAttribute('for');
    const input = document.getElementById(id);
    if (!input) return;

    // Click the real radio so your existing JS runs
    input.click();

    // Defer UI updates until after radio handlers execute
    requestAnimationFrame(() => {
      updateBarValues(); // keep label text in sync
      document.querySelectorAll('.fx-dd.open').forEach(dd => dd.classList.remove('open'));
    });
  }, {passive:false});

  // Reflect current radio state into the bar's value labels
  function updateBarValues(){
    const rq = document.querySelector('input[name="rim-quality"]:checked');
    const rqOut = document.getElementById('fxValRimQuality');
    if (rq && rqOut) rqOut.textContent = ({off:'Off',low:'Low',med:'Med',high:'High'})[rq.value] || rq.value;

    const rd = document.querySelector('input[name="rim-diameter"]:checked');
    const rdOut = document.getElementById('fxValRimDiameter');
    if (rd && rdOut) rdOut.textContent =
      rd.id === 'rim-diam-sm' ? 'Small' :
      rd.id === 'rim-diam-med' ? 'Medium' :
      rd.id === 'rim-diam-large' ? 'Large' : rd.value;
  }

  // Keep in sync if radios change from anywhere else in your app
  document.querySelectorAll('input[name="rim-quality"], input[name="rim-diameter"]').forEach(r=>{
    r.addEventListener('change', updateBarValues);
    r.addEventListener('input', updateBarValues);
  });
  updateBarValues();

  // Mute in the bar
  (function wireMute(){
    const btn = document.getElementById('muteBtn');
    const amb = document.getElementById('bf-ambience');
    const flip = document.getElementById('coinFlipSound');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const next = btn.getAttribute('aria-pressed') !== 'true';
      btn.setAttribute('aria-pressed', String(next));
      btn.textContent = next ? 'Muted' : 'Mute';
      if (amb) { amb.muted = next; if (!next && amb.paused) amb.play?.().catch(()=>{}); }
      if (flip) flip.muted = next;
    });
  })();

// ====== IMAGE UPLOAD UI =======
const input = document.getElementById('artFile');
const preview = document.getElementById('image-preview');
const previewFaux = document.getElementById('image-preview-faux');

input.addEventListener('change', () => {
  const file = input.files && input.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = e => {
    preview.src = e.target.result;
    preview.style.display = 'block';
    previewFaux.style.display = 'none'
  };
  reader.readAsDataURL(file);
});
